import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Moment from 'moment';
import { getSalesPerformancePerSales } from 'src/services/SalesPerformance/SalesPerformance';
import {
  CButton,
  CCard,
  CCol,
  CHeader,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow
} from '@coreui/react';
import { DateRangePicker } from 'react-date-range';
import SummaryDownload from '../summary/Download/Summary';
import ls from 'local-storage';
import { getMerchantList } from 'src/services/MerchantList/MerchantList';

function SalesPerformanceDetails() {
  const navigate = useNavigate();

  const [summaryData, setSummaryData] = useState([]);

  const [byDeals, setByDeals] = useState([]);
  const [byPackage, setByPackage] = useState([]);
  const [byPos, setByPos] = useState([]);
  const [drModal, setDrModal] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [dataMerchant, setDataMerchant] = useState([]);

  const endDay = Moment(new Date()).format('YYYY-MM-DD');
  const max = new Date(endDay);

  async function fetchGetMerchant(salesID, from, to, type) {
    const response = await getMerchantList(salesID, from, to, type);

    setDataMerchant(response.data);
  }

  const [dateRange, setDateRange] = useState([
    {
      // startDate: ls.get("dateRange") ? new Date(ls.get("dateRange").startDate) : new Date(`${Moment(new Date()).startOf('month').format("MMM dd YYYY")}`),
      startDate: new Date(
        `${Moment(new Date()).startOf('month').format('MMM dd YYYY')}`
      ),
      endDate: new Date()
    }
  ]);
  // endDate: ls.get("dateRange") ? new Date(ls.get("dateRange").endDate) : new Date()}])

  function toSQLDateFormat(date) {
    return Moment(new Date(date)).format('YYYY-MM-DD');
  }

  useEffect(() => {
    const newStartDay = toSQLDateFormat(dateRange[0].startDate);
    const newEndDay = toSQLDateFormat(dateRange[0].endDate);

    fetchGetMerchant('', newStartDay, newEndDay, 'merchantHighlight');
  }, [refetch, dateRange]);

  return (
    <>
      <CModal
        visible={drModal}
        style={{
          width: 'fit-content'
        }}
        onClose={() => {
          setDrModal(false);
        }}
      >
        <CModalHeader>
          <CModalTitle>Modal title</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CCol xs="12" lg="10">
            <DateRangePicker
              onChange={(item) => {
                setDateRange([item.range1]);
                ls.set('dateRange', item.range1);
              }}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={1}
              maxDate={max}
              ranges={dateRange}
              direction="vertical"
              weekStartsOn={1}
              calendarFocus="backwards"
              preventSnapRefocus={true}
              rangeColors={['#4E5B97']}
            />
          </CCol>
        </CModalBody>
        <CModalFooter>
          <CButton
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            onClick={() => {
              setRefetch(true);
              setDrModal(false);
            }}
          >
            OK
          </CButton>
          <CButton
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            onClick={() => setDrModal(!drModal)}
          >
            Close
          </CButton>
        </CModalFooter>
      </CModal>
      <CCol xs="12 bg-light">
        <CCol>
          <CButton
            className="ml-3 mb-3 btn btn-dark"
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            hover="true"
            onClick={() => {
              setDrModal(!drModal);
            }}
          >
            <div>
              {Moment(dateRange[0].startDate).format('ll')}
              {' - '}
              {Moment(dateRange[0].endDate).format('ll')}
            </div>
          </CButton>
        </CCol>

        <CCard style={{ padding: '2vh 2vw' }}>
          <CRow>
            <CCol xs={6}>
              <p className="fs-3 fw-bold">DATA ACTIVE MERCHANT</p>
            </CCol>

            {/* <CCol xs={6} style={{textAlign: "right"}}>
                            <SummaryDownload 
                                dateFrom={toSQLDateFormat(dateRange[0].startDate)}
                                dateUntil={toSQLDateFormat(dateRange[0].endDate)}
                                byPos={byPos}
                                byPackage={byPackage}
                                byDeals={byDeals}
                                total={summaryData.total}
                                totalDeals={summaryData.totalDeal}
                                totalPOS={summaryData.totalPOS}
                                totalPackage={summaryData.totalPackage}
                            />
                        </CCol> */}
          </CRow>
          <div className="mt-3 mb-3">
            <CRow className="text-uppercase fs-6 fw-bolder">
              {/* <span>NAMA SALES: {location.state.salesName}</span> */}
            </CRow>
            <CRow className="fs-6">
              {/* <span>{location.state.salesEmail}</span> */}
            </CRow>
            <CRow className="fs-6">
              {/* <span>{location.state.salesPhone}</span> */}
            </CRow>
          </div>
          <div className="mt-3 mb-3">
            {dataMerchant.length > 0 ? (
              <CTable align="middle" className="mb-5 border" hover responsive>
                <CTableHead
                  style={{ backgroundColor: '#4E5B97', color: 'white' }}
                >
                  <CTableRow>
                    <CTableHeaderCell className="text-center">
                      Nama Partner
                    </CTableHeaderCell>
                    <CTableHeaderCell className="text-center">
                      Jumlah Transaksi
                    </CTableHeaderCell>
                    <CTableHeaderCell className="text-center">
                      Durasi
                    </CTableHeaderCell>
                    <CTableHeaderCell className="text-center">
                      Tanggal Bergabung
                    </CTableHeaderCell>
                    <CTableHeaderCell className="text-center">
                      Rata-Rata Transaksi
                    </CTableHeaderCell>
                    <CTableHeaderCell className="text-center">
                      Subtotal
                    </CTableHeaderCell>
                    <CTableHeaderCell className="text-center">
                      Nama Sales
                    </CTableHeaderCell>
                    <CTableHeaderCell className="text-center">
                      Tipe Berlangganan
                    </CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody style={{ backgroundColor: '#fff' }}>
                  {dataMerchant &&
                    dataMerchant.map((item, index) => (
                      <CTableRow v-for="item in tableItems" key={index}>
                        <CTableDataCell className="text-center">
                          {item.partnerName}
                        </CTableDataCell>
                        <CTableDataCell className="text-center">
                          <div>{item.counter}</div>
                        </CTableDataCell>
                        <CTableDataCell className="text-center">
                          <div>{item.duration} Hari</div>
                        </CTableDataCell>
                        <CTableDataCell className="text-center">
                          <div>{item.joinDate}</div>
                        </CTableDataCell>
                        <CTableDataCell className="text-center">
                          <div>
                            {new Intl.NumberFormat('id-ID', {
                              style: 'currency',
                              currency: 'IDR'
                            }).format(parseFloat(item.averageTrx))}
                          </div>
                        </CTableDataCell>
                        <CTableDataCell className="text-center">
                          <div>
                            {new Intl.NumberFormat('id-ID', {
                              style: 'currency',
                              currency: 'IDR'
                            }).format(parseFloat(item.subtotal))}
                          </div>
                        </CTableDataCell>
                        <CTableDataCell className="text-center">
                          <div>{item.salesName}</div>
                        </CTableDataCell>
                        <CTableDataCell className="text-center">
                          <div>{item.primary_subscription_id}</div>
                        </CTableDataCell>
                      </CTableRow>
                    ))}
                </CTableBody>
              </CTable>
            ) : (
              <CHeader style={{ color: 'silver', marginBottom: '2vh' }}>
                <p style={{ padding: '0vh 0vw 0vh 2vw' }}>
                  Data Tidak Ditemukan
                </p>
              </CHeader>
            )}
          </div>
        </CCard>
      </CCol>
    </>
  );
}

export default SalesPerformanceDetails;
